import axios from 'axios';
import { API_BASE_URL } from '../config/api';

const API_BASE = `${API_BASE_URL}/api/emission-factors`;

export const emissionFactorService = {
  async searchFactor(activityDescription, context = {}, topK = 5) {
    const response = await axios.post(`${API_BASE}/search`, {
      activity_description: activityDescription,
      context,
      top_k: topK,
    });
    return response.data;
  },

  async validateFactor(entityType, entityId, activityDescription, selectedFactorId) {
    const response = await axios.post(`${API_BASE}/validate`, {
      entity_type: entityType,
      entity_id: entityId,
      activity_description: activityDescription,
      selected_factor_id: selectedFactorId,
    });
    return response.data;
  },

  async ingestFactor(factorData) {
    const response = await axios.post(`${API_BASE}/ingest`, factorData);
    return response.data;
  },

  async bulkIngest(factors) {
    const response = await axios.post(`${API_BASE}/ingest/bulk`, { factors });
    return response.data;
  },

  async getValidationHistory(entityType, entityId) {
    const response = await axios.get(`${API_BASE}/validation-history/${entityType}/${entityId}`);
    return response.data;
  },
};

export default emissionFactorService;
